module.exports = __webpack_public_path__ + "assets/img/img-hotel-02.fb45a5ae.jpg";